/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ klas: NonNullable<unknown>, lesuur: NonNullable<unknown>, dag: NonNullable<unknown>, docent: NonNullable<unknown> }} Planning_Rooster_LesInputs */

const nl_planning_rooster_les = /** @type {(inputs: Planning_Rooster_LesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Les van ${i?.klas} in het ${i?.lesuur} op ${i?.dag}, gegeven door ${i?.docent}`)
};

/**

* @param {Planning_Rooster_LesInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_les = /** @type {((inputs: Planning_Rooster_LesInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_LesInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_les(inputs)
});
export { planning_rooster_les as "planning.rooster.les" }